import CollapsibleContent from "./CollapsibleContent";
import { withBlockVoidType } from "../../utils";

const NODE_TYPE_COLLAPSIBLE_TEXT = "collapsible-text";

// Constants from bronte-lib-components
const FORMATS = {
  horizontal: "horizontal",
  vertical: "vertical",
  none: "none",
};

const ICON_POSITIONS = {
  left: "left",
  right: "right",
};

const ICON_STYLES = {
  arrow: "expand-collapse",
  sign: "plus-minus",
  check: "check-x",
};

export default function CollapsibleText() {
  const plugin = (editor: any) => {
    withBlockVoidType(editor, NODE_TYPE_COLLAPSIBLE_TEXT);
    return editor;
  };

  plugin.renderElement = ({ element, attributes, children }: any) => {
    console.log("CollapsibleText: ", element, attributes, children);
    if (element.type !== NODE_TYPE_COLLAPSIBLE_TEXT) {
      return undefined;
    }

    const { data } = element;
    const showTitle = data.showTitle || "Show";
    const hideTitle = data.hideTitle || "Hide";
    const iconPos = data.iconPos || ICON_POSITIONS.left;
    const iconStyle = data.iconStyle || ICON_STYLES.arrow;
    const format = data.format || FORMATS.horizontal;
    let isIconUsed = data.isIconUsed;
    if (typeof isIconUsed === "undefined" || isIconUsed === null) {
      isIconUsed = true;
    }

    const collapsibleData = { showTitle, hideTitle, isIconUsed, iconPos, iconStyle, format };

    return (
      <CollapsibleContent attributes={attributes} collapsibleData={collapsibleData} readOnly={true}>
        {children}
      </CollapsibleContent>
    );
  };

  return plugin;
}
